import React, { useState } from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import './FAQsSection.scss';
// JSON data as provided
interface FAQQuestionInterface {
    question: String;
    answer: String;
}

export interface FAQSectionInterface {
    categoryTitle: String;
    questions: FAQQuestionInterface[];
}

interface FAQSectionProps {
    faqSection: any
    questionFocusBackgroundColor?: string
    questionNonFocusBackgroundColor?: string
    answerBackgroundColor?: string
}

const FAQsSection = ({faqSection, 
                        questionFocusBackgroundColor, 
                        questionNonFocusBackgroundColor,
                        answerBackgroundColor}: FAQSectionProps) => {
  const [expandedIndex, setExpandedIndex] = useState(-1);

  const handleChange = (panelIndex: number) => {
    if (expandedIndex === panelIndex) setExpandedIndex(-1)
    else setExpandedIndex(panelIndex);
  };

  return (
    <div className='FAQs-section'>
      {faqSection.questions.map((item: any, index: number) => (
        <Accordion
          disableGutters
          key={index}
          expanded={index === expandedIndex}
          onClick={() => {handleChange(index)}}
        >
          <AccordionSummary
            expandIcon={index === expandedIndex ? <RemoveIcon /> : <AddIcon />}
            aria-controls={`panel${index}bh-content`}
            id={`panel${index}bh-header`}
            style={{ 
              borderTop: index !== 0 ? '1px solid rgba(0, 0, 0, .125)' : '',
              backgroundColor: index === expandedIndex ? questionFocusBackgroundColor : questionNonFocusBackgroundColor,
              padding: '8px 30px',
            }} 
          >
            <Typography>
                {item.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails  
            style={{ 
              padding: '18px 30px',
              backgroundColor: answerBackgroundColor,
            }} 
          >
            <Typography>{item.answer}</Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};

export default FAQsSection;
